"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactQuery = require("react-query");
var _reactI18next = require("react-i18next");
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _clsx = _interopRequireDefault(require("clsx"));
var _axios = _interopRequireDefault(require("axios"));
var _moment2 = _interopRequireDefault(require("moment"));
var _ReactMetadata = _interopRequireDefault(require("@micado-digital/react-metadata/ReactMetadata01"));
var _contactSection = _interopRequireDefault(require("../../components/contact-section"));
var _elementHeadline = _interopRequireDefault(require("../../components/element-headline"));
var _themeTeaser = _interopRequireDefault(require("../../components/theme-teaser"));
var _pageContext = _interopRequireDefault(require("../../context/pageContext"));
var _changeLanguage = _interopRequireDefault(require("../../utils/changeLanguage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    paddingTop: theme.spacing(4)
  },
  textWrapper: {
    order: 2,
    [theme.breakpoints.up("md")]: {
      order: 1
    }
  },
  teaserWrapper: {
    order: 1,
    [theme.breakpoints.up("md")]: {
      order: 2
    }
  },
  infoWrapper: {
    background: theme.palette.background.light,
    padding: theme.spacing(2.5, 2)
  },
  infoItem: {
    "& + div": {
      borderTop: "1px solid ".concat(theme.palette.divider),
      margin: theme.spacing(1, 0, 0),
      padding: theme.spacing(1, 0, 0)
    }
  },
  infoLabel: {
    ...theme.customTypography.infoLabel
  },
  periodEntry: {
    "& + div": {
      marginTop: theme.spacing(2)
    }
  },
  periodTitle: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(0.5)
  },
  periodText: {}
}));
const Info = _ref => {
  let {
    place,
    periods
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  if (!periods) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const address = [];
  if (place !== null && place !== void 0 && place.company) {
    address.push(place === null || place === void 0 ? void 0 : place.company);
  }
  if (place !== null && place !== void 0 && place.street) {
    address.push(place === null || place === void 0 ? void 0 : place.street);
  }
  if (place !== null && place !== void 0 && place.town) {
    address.push(place === null || place === void 0 ? void 0 : place.town);
  }
  const Weekdays = _ref2 => {
    let {
      wd
    } = _ref2;
    const x = [];
    if ((wd & 1 << 0) === 1) x.push(t("site.ui.weekDays.0"));
    if ((wd & 2 << 0) === 2) x.push(t("site.ui.weekDays.1"));
    if ((wd & 4 << 0) === 4) x.push(t("site.ui.weekDays.2"));
    if ((wd & 8 << 0) === 8) x.push(t("site.ui.weekDays.3"));
    if ((wd & 16 << 0) === 16) x.push(t("site.ui.weekDays.4"));
    if ((wd & 32 << 0) === 32) x.push(t("site.ui.weekDays.5"));
    if ((wd & 64 << 0) === 64) x.push(t("site.ui.weekDays.6"));
    return x.join(", ");
  };
  const ParsePeriods = () => {
    const HTML = () => {
      return periods === null || periods === void 0 ? void 0 : periods.map((period, counter) => {
        const {
          weekdays,
          dateFrom,
          dateTo,
          dates,
          timeFrom,
          duration
        } = period;
        const dateFromString = (0, _moment2.default)(dateFrom).format("L");
        const dateToString = (0, _moment2.default)(dateTo).format("L");
        let timeString = "";
        if (timeFrom) {
          timeString += timeFrom.split(":")[0] + ":" + timeFrom.split(":")[1];
        }

        // calculate endTime (from duration)

        let endTime = null;
        if (dates && duration > 0) {
          var _dates$, _detectEndDateFromDur;
          const firstDayWithTime = new Date((_dates$ = dates[0]) === null || _dates$ === void 0 ? void 0 : _dates$.startDate);
          endTime = (_detectEndDateFromDur = detectEndDateFromDuration(firstDayWithTime, duration)) === null || _detectEndDateFromDur === void 0 ? void 0 : _detectEndDateFromDur.format("LT");
        }
        if (endTime) {
          if (timeFrom !== "") {
            timeString = t("site.event.eachTimeFrom") + " " + timeString;
          }
          timeString += " - " + endTime + " " + t("site.event.oclock");
        } else if (timeFrom !== "" && !endTime) {
          timeString = t("site.event.at") + " " + timeString;
        }
        return /*#__PURE__*/_react.default.createElement("div", {
          className: css.periodEntry,
          key: counter
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: css.periodTitle
        }, "".concat(dateFromString).concat(dateToString && dateFromString !== dateToString ? " - ".concat(dateToString) : "")), /*#__PURE__*/_react.default.createElement("div", {
          className: css.periodText
        }, /*#__PURE__*/_react.default.createElement(Weekdays, {
          wd: weekdays
        }), " ", timeString));
      });
    };
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(HTML, null));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: css.infoWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: css.infoItem
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: css.infoLabel
  }, "Termine")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 9
  }, /*#__PURE__*/_react.default.createElement(ParsePeriods, null))), place && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: css.infoItem
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: css.infoLabel
  }, t("site.ui.labels.place"))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 9
  }, address.join(", "))));
};
const LayoutEvent = _ref3 => {
  var _data$data, _data$data2, _data$data3, _data$data4;
  let {
    match
  } = _ref3;
  const {
    params
  } = match;
  const {
    lang,
    pagename
  } = params;
  const {
    REACT_APP_PATH
  } = process.env;
  const [pageData, setPageData] = (0, _react.useContext)(_pageContext.default);
  const {
    i18n,
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  (0, _react.useEffect)(() => {
    var _pageData$data;
    if ((pageData === null || pageData === void 0 || (_pageData$data = pageData.data) === null || _pageData$data === void 0 || (_pageData$data = _pageData$data.meta) === null || _pageData$data === void 0 ? void 0 : _pageData$data.title) === t("site.ui.pagetitles.event")) {
      return;
    }
    const additionalPageData = {
      ...pageData
    };
    additionalPageData.data = {
      ...pageData.data,
      meta: {
        title: t("site.ui.pagetitles.event")
      }
    };
    setPageData(additionalPageData);
  });
  const url = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.EventApi/Details.api?pagename=/").concat(lang, "/event/").concat(pagename, "&lang=").concat(lang);
  const {
    data,
    status
  } = (0, _reactQuery.useQuery)(["event-details", lang, pagename], () => _axios.default.get(url));
  if (status !== "success") return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  if (lang !== i18n.language) {
    (0, _changeLanguage.default)(i18n, lang);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const formatData = data => {
    var _data$periods, _data$periods2, _data$periods3, _data$media;
    const val = data === null || data === void 0 || (_data$periods = data.periods) === null || _data$periods === void 0 || (_data$periods = _data$periods[0]) === null || _data$periods === void 0 || (_data$periods = _data$periods.dates[0]) === null || _data$periods === void 0 ? void 0 : _data$periods.startDate;
    let startDate = val && new Date(data === null || data === void 0 || (_data$periods2 = data.periods) === null || _data$periods2 === void 0 || (_data$periods2 = _data$periods2[0]) === null || _data$periods2 === void 0 || (_data$periods2 = _data$periods2.dates[0]) === null || _data$periods2 === void 0 ? void 0 : _data$periods2.startDate);
    let endDate = detectEndDateFromDuration(startDate, data === null || data === void 0 || (_data$periods3 = data.periods) === null || _data$periods3 === void 0 || (_data$periods3 = _data$periods3[0]) === null || _data$periods3 === void 0 ? void 0 : _data$periods3.duration);
    return {
      teaser: {
        id: data === null || data === void 0 ? void 0 : data.id,
        media: (_data$media = data === null || data === void 0 ? void 0 : data.media) !== null && _data$media !== void 0 ? _data$media : [],
        title: data === null || data === void 0 ? void 0 : data.title,
        timeFrom: startDate,
        timeTo: endDate
      }
    };
  };
  const teaser = formatData(data === null || data === void 0 ? void 0 : data.data);
  const {
    email,
    periods,
    phone
  } = data === null || data === void 0 ? void 0 : data.data;
  const description = data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 || (_data$data = _data$data.descriptions) === null || _data$data === void 0 ? void 0 : _data$data.find(item => item.type === "standard").description;
  const address = data === null || data === void 0 || (_data$data2 = data.data) === null || _data$data2 === void 0 || (_data$data2 = _data$data2.addresses) === null || _data$data2 === void 0 ? void 0 : _data$data2.find(address => address.type === "organizer");
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ReactMetadata.default, {
    lang: i18n.language,
    title: data === null || data === void 0 || (_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.title
  }), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: (0, _clsx.default)(css.root, "event-detail")
  }, /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
    title: data === null || data === void 0 || (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.title,
    component: "h1"
  }), /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.textWrapper,
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "div"
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description
    }
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.teaserWrapper,
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_themeTeaser.default, {
    data: teaser,
    marginY: 0,
    mediaFormat: "event-theme-teaser",
    showBookmark: true
  })))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(Info, {
    periods: periods,
    place: address
  })), (email || phone) && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_contactSection.default, {
    email: email,
    phone: phone
  }))))));
};
const detectEndDateFromDuration = (startDate, duration) => {
  if (_moment2.default.isDate(startDate)) {
    var _moment;
    return (_moment = (0, _moment2.default)(startDate)) === null || _moment === void 0 ? void 0 : _moment.add(duration, "minutes");
  } else {
    return null;
  }
};
var _default = exports.default = LayoutEvent;